import { createContext, useContext } from 'react'

import { PaywallModalComponentId } from '@/components/common/modals/PaywallModal'
import { PaywallOptions } from '@/hooks/usePaywallModal'

export type ShowPaywallModal = (
  id: PaywallModalComponentId,
  options?: PaywallOptions
) => void | null

export const PaywallContext = createContext<{
  hidePaywallModal: () => void
  showPaywallModal: ShowPaywallModal
}>(undefined)

PaywallContext.displayName = 'PaywallContext'

export const usePaywallContext = () => useContext(PaywallContext)
